// extracted by mini-css-extract-plugin
export default {"root":"DashboardHero_root__i8dv1","imageMobile":"DashboardHero_imageMobile__sL+tX","imageDesktop":"DashboardHero_imageDesktop__2Idg8"};